import RadioContext from "./RadioContext";

function RadioGroup({ label, children, ...rest }) {
  return (
    <fieldset style={{border:"0px"}}>
      <legend>{label}</legend>
      <RadioContext.Provider value={rest}>{children}</RadioContext.Provider>
    </fieldset>
  );
}

export default RadioGroup;